import { render, staticRenderFns } from "./CarPerformance.vue?vue&type=template&id=799d9056&scoped=true"
import script from "./CarPerformance.vue?vue&type=script&lang=js"
export * from "./CarPerformance.vue?vue&type=script&lang=js"
import style0 from "./CarPerformance.vue?vue&type=style&index=0&id=799d9056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d9056",
  null
  
)

export default component.exports